module.exports = __webpack_public_path__ + "static/media/stripe.12d8c3aa.png";